import { createFileRoute, Outlet, Navigate } from '@tanstack/react-router'
import { useRole } from '@/hooks/use-permissions'
import { useUserStore, selectIsProfileReady } from '@/stores/user.store'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const Route = createFileRoute('/_authenticated/admin' as any)({
  component: AdminLayout,
})

function AdminLayout() {
  const role = useRole()
  const isProfileReady = useUserStore(selectIsProfileReady)

  if (!isProfileReady) {
    return null
  }

  if (role !== 'GREYBULL_ADMIN') {
    return <Navigate to="/companies" />
  }

  return <Outlet />
}
